import { Rendered } from "../rendered";
import { Para } from "./para";

export class Post {
  private _id: number;
  private _slug: string;
  private _title: Rendered
  private _content: Rendered;
  private _next: number;
  private _previous: number;
  private _game_type: string;
  // game word
  private _game_word_1: string;
  private _game_word_2: string;
  // game memory
  private _game_para: Array<Para> = [];
  // game puzzle
  private _game_puzzle_parts: Array<string> = [];
  private _game_puzzle_password: string;
  private _game_puzzle_definition: string;
  private _game_puzzle_count: number;

  constructor(data: any = null) {
    if (data) {
      this.normalize(data);
    }
  }  

  public normalize(data: any = null) {
    let regexpMemory = new RegExp('^game_para_');
    for (const prop in data) {
      if (regexpMemory.test(prop)) {
        this._game_para.push(
          new Para(data[prop].split(','))
        );
      } else if ('game_puzzle_parts' === prop) {
        this._game_puzzle_parts = data[prop].split(',');
      } else if (('next' === prop) || ('previous' === prop)) {
        this[prop] = (data[prop])? data[prop].id : null;
      } else if (! (data[prop] instanceof Object) && ! (data[prop] instanceof Array)) {
        this[prop] = data[prop];      
      } else if ('title' === prop || 'content' === prop) {
        this[prop] = new Rendered(data[prop]);
      }
    }
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get next(): number {
    return this._next;
  }

  set next(value: number) {
    this._next = value;
  }

  get previous(): number {
    return this._previous;
  }

  set previous(value: number) {
    this._previous = value;
  }

  get slug(): string {
    return this._slug;
  }

  set slug(value: string) {
    this._slug = value;
  }
  
  get title(): Rendered {
    return this._title;
  }

  set title(value: Rendered) {
    this._title = value;
  }
  
  get content(): Rendered {
    return this._content;
  }

  set content(value: Rendered) {
    this._content = value;
  }

  get game_type(): string {
    return this._game_type;
  }

  set game_type(value: string) {
    this._game_type = value;
  }

  get game_word_1(): string {
    return this._game_word_1;
  }

  set game_word_1(value: string) {
    this._game_word_1 = value;
  }

  get game_word_2(): string {
    return this._game_word_2;
  }

  set game_word_2(value: string) {
    this._game_word_2 = value;
  }

  get game_para(): Array<Para> {
    return this._game_para;
  }

  set game_para(value: Array<Para>) {
    this._game_para = value;
  }

  public randomPara() {
    let tiles: Array<{}> = [];
    let random: Array<any> = this._shuffle(this.game_para);
    for (let i = 0; i < 6; i++) {
      tiles.push({
        tile: random[i].adres1,
        para: random[i],
        open: false
      });
      tiles.push({
        tile: random[i].adres2,
        para: random[i],
        open: false
      }); 
    }
    // this.game_para.forEach(para => {
    //   tiles.push({
    //     tile: para.adres1,
    //     para: para
    //   });
    //   tiles.push({
    //     tile: para.adres2,
    //     para: para
    //   });
    // });
    return this._shuffle(tiles);
  }

  private _shuffle(array: Array<{}>) {
    let currentIndex: number = array.length;
    let temporaryValue: {};
    let randomIndex: number;
  
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array;
  }

  get game_puzzle_parts(): Array<string> {
    return this._game_puzzle_parts;
  }

  set game_puzzle_parts(value: Array<string>) {
    this._game_puzzle_parts = value;
  }

  get game_puzzle_count(): number {
    return this._game_puzzle_count;
  }

  set game_puzzle_count(value: number) {
    this._game_puzzle_count = value;
  }

  get game_puzzle_password(): string {
    return this._game_puzzle_password;
  }

  set game_puzzle_password(value: string) {
    this._game_puzzle_password = value;
  }

  get game_puzzle_definition(): string {
    return this._game_puzzle_definition;
  }

  set game_puzzle_definition(value: string) {
    this._game_puzzle_definition = value;
  }
  
  public randomPuzzleParts() {    
    return this._shuffle(this.game_puzzle_parts);
  }
}
